module.exports = __webpack_public_path__ + "img/manualflow.686a25c2.jpg";